import { Link } from "react-router-dom";
const NavBarBLogin = () => {
  return (
    <nav className="nav-bar">
      <div className="nav-homeTitle">
        <Link to="/">
          <h1>Relation Apps</h1>
        </Link>
      </div>
      <div className="links">
        <Link to="/Katalog">Katalog</Link>
        <Link to="/">Tentang Kami</Link>
        <Link to="/Kelas">Kelas</Link>
        <a href="/">Contact</a>
        <Link to="/Login">Login</Link>
      </div>
    </nav>
  );
};

export default NavBarBLogin;
